import { Feather, Flower2, HeartHandshake, Moon, Scan, Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

const BENEFITS = [
    {
        icon: Flower2,
        title: "Deep Relaxation",
        text: "Slow, unhurried sessions are traditionally sought to unwind the stress of everyday life.",
    },
    {
        icon: Sparkles,
        title: "A Sense of Balance",
        text: "In classical tradition, marma work aims to settle and centre — body and mind together.",
    },
    {
        icon: Feather,
        title: "Ease of Everyday Tension",
        text: "Traditionally sought for tight shoulders, a tired back, and heaviness after long working days.",
    },
    {
        icon: Scan,
        title: "Body Awareness",
        text: "Quiet, attentive touch encourages you to notice and reconnect with your own body.",
    },
    {
        icon: Moon,
        title: "Restful Routines",
        text: "Many guests make sessions part of their routine for calmer evenings and better rest habits.",
    },
    {
        icon: HeartHandshake,
        title: "Complementary Care",
        text: "Sits alongside — never replaces — the guidance of your physician and your ongoing care.",
    },
];

export default function Benefits() {
    return (
        <section id="benefits" data-testid="benefits-section" className="bg-bone py-20 md:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    overline="Benefits"
                    title="What Guests Traditionally Seek"
                    testId="benefits-heading"
                >
                    People visit our Kurnool wellness centre for many reasons. These are the traditional
                    aims of the practice — experiences vary from person to person.
                </SectionHeading>

                <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {BENEFITS.map((b, i) => (
                        <Reveal key={b.title} delay={i * 0.07}>
                            <div
                                data-testid={`benefit-card-${i}`}
                                className="group h-full rounded-3xl border border-sand bg-cream p-8 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(28,35,33,0.25)]"
                            >
                                <span className="inline-flex rounded-2xl bg-forest/10 p-3 text-forest transition-colors duration-500 group-hover:bg-forest group-hover:text-cream">
                                    <b.icon className="h-5 w-5" />
                                </span>
                                <h3 className="mt-5 font-serif text-2xl font-medium text-ink">{b.title}</h3>
                                <p className="mt-2.5 text-sm leading-relaxed text-moss">{b.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <p className="mt-10 max-w-2xl text-xs leading-relaxed text-moss/80">
                        These reflect traditional wellness aims, not guaranteed medical outcomes. Marma
                        Chikitsa is a complementary practice and is not intended to diagnose, treat, cure
                        or prevent any disease.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
